import { HEX_HEIGHT_FACTOR } from '~/composables/grid/constants'
import type { Shape } from '~/types/grid.types'
import { SHAPE_IDS } from './shapesIdsFreeform'

export const HEX_DIAMOND_TRIANGLE_FREEFORM_SHAPES: Shape[] = [
  {
    type: 'hex',
    id: SHAPE_IDS.HEX,
    icon: 'Hex',
    prefix: 'Hex',
    label: 'Hex',
    w: 120,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    sides: 6,
    radius: 60,
    rotation: 90,
    children: [
      {
        type: 'hex',
        id: SHAPE_IDS.HEX_90,
        icon: 'Hex',
        prefix: 'Hex',
        label: 'Hex',
        w: 120,
        h: Math.round(120 * HEX_HEIGHT_FACTOR),
        sides: 6,
        radius: 60,
        rotation: 0,
      },
    ],
  },
  {
    type: 'diamond',
    id: SHAPE_IDS.LARGE_DIAMOND,
    icon: 'LargeDiamond',
    prefix: 'LargeDiamond',
    label: 'Large Diamond',
    w: 120,
    h: Math.round(240 * HEX_HEIGHT_FACTOR),
    children: [
      {
        type: 'diamond',
        id: SHAPE_IDS.LARGE_DIAMOND_60,
        icon: 'LargeDiamond',
        prefix: 'LargeDiamond',
        label: 'Large Diamond 60',
        w: 120,
        h: Math.round(240 * HEX_HEIGHT_FACTOR),
        rotation: 60,
      },
      {
        type: 'diamond',
        id: SHAPE_IDS.LARGE_DIAMOND_120,
        icon: 'LargeDiamond',
        prefix: 'LargeDiamond',
        label: 'Large Diamond 120',
        w: 120,
        h: Math.round(240 * HEX_HEIGHT_FACTOR),
        rotation: 120,
      },
    ],
  },
  {
    type: 'diamond',
    id: SHAPE_IDS.SMALL_DIAMOND,
    icon: 'SmallDiamond',
    prefix: 'Diamond',
    label: 'Small Diamond',
    w: 60,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    children: [
      {
        type: 'diamond',
        id: SHAPE_IDS.SMALL_DIAMOND_60,
        icon: 'SmallDiamond',
        prefix: 'Diamond',
        label: 'Small Diamond 60',
        w: 60,
        h: Math.round(120 * HEX_HEIGHT_FACTOR),
        rotation: 60,
      },
      {
        type: 'diamond',
        id: SHAPE_IDS.SMALL_DIAMOND_120,
        icon: 'SmallDiamond',
        prefix: 'Diamond',
        label: 'Small Diamond 120',
        w: 60,
        h: Math.round(120 * HEX_HEIGHT_FACTOR),
        rotation: 120,
      },
    ],
  },
  {
    type: 'triangle',
    id: SHAPE_IDS.LARGE_TRIANGLE_TOP,
    icon: 'LargeTriangle',
    prefix: 'LargeTriangle',
    label: 'Large Triangle',
    w: 120,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    children: [
      {
        type: 'triangle',
        id: SHAPE_IDS.LARGE_TRIANGLE_BOTTOM,
        icon: 'LargeTriangle',
        prefix: 'LargeTriangle',
        label: 'Large Triangle Flipped',
        rotation: 180,
        w: 120,
        h: Math.round(120 * HEX_HEIGHT_FACTOR),
      },
    ],
  },
  {
    type: 'triangle',
    id: SHAPE_IDS.SMALL_TRIANGLE_TOP,
    icon: 'SmallTriangle',
    prefix: 'SmallTriangle',
    label: 'Small Triangle',
    w: 60,
    h: Math.round(60 * HEX_HEIGHT_FACTOR),
    children: [
      {
        type: 'triangle',
        id: SHAPE_IDS.SMALL_TRIANGLE_BOTTOM,
        icon: 'SmallTriangle',
        prefix: 'SmallTriangle',
        label: 'Small Triangle Flipped',
        rotation: 180,
        w: 60,
        h: Math.round(60 * HEX_HEIGHT_FACTOR),
      },
    ],
  },
]
